import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';

declare var google;

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsAutocompleteService {

  constructor() { }

  getPlacePredictions(input: string): Observable<any[]> {
    return new Observable((observer: Observer<any[]>) => {
      const autocompleteService = new google.maps.places.AutocompleteService();
      const request = {
        input: input,
        componentRestrictions: { country: 'fr' }
      };
      autocompleteService.getPlacePredictions(request, (predictions, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && predictions) {
          observer.next(predictions.map(prediction => ({
            description: prediction.description,
            placeId: prediction.place_id
          })));
        } else {
          observer.next([]);
        }
        observer.complete();
      });
    });
  }

  getParsedAddress(placeId: string): Observable<any> {
    return new Observable((observer: Observer<any>) => {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ placeId }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK && results[0]) {
          const addressComponents = results[0].address_components;
          const parsedAddress = {
            streetNumber: this.getComponent(addressComponents, 'street_number'),
            streetName: this.getComponent(addressComponents, 'route'),
            city: this.getComponent(addressComponents, 'locality'),
            postalCode: this.getComponent(addressComponents, 'postal_code'),
            country: this.getComponent(addressComponents, 'country')
          };
          observer.next(parsedAddress);
        } else {
          observer.error('Failed to get address details');
        }
        observer.complete();
      });
    });
  }

  private getComponent(components: any[], type: string): string {
    const component = components.find(c => c.types.includes(type));
    return component ? component.long_name : '';
  }


}
